// Sıra TS3 permissionlist ile birebir aynıdır (array sırası korunur).
// tr / desc_tr alanlarını TS3'e bakarak sen dolduracaksın.

export const PERM_TR_LIST = [
  {
    "key": "b_serverinstance_help_view",
    "tr": "ServerQuery: Durum Mesajlarını Al",
    "desc_tr": "ServerQuery komutları hakkında bilgi alır",
    "desc_en": "Retrieve information about ServerQuery commands"
  },
  {
    "key": "b_serverinstance_info_view",
    "tr": "ServerQuery: Sunucu Durum Bilgilerini Al",
    "desc_tr": "Genel sunucu bilgilerini alır",
    "desc_en": "Retrieve global server information"
  },
  {
    "key": "b_serverinstance_virtualserver_list",
    "tr": "ServerQuery: Sunucu Listesini Al",
    "desc_tr": "Veritabanında kayıtlı sanal sunucuları listeler",
    "desc_en": "List virtual servers stored in the database"
  },
  {
    "key": "b_serverinstance_binding_list",
    "tr": "ServerQuery: Sunucu IP Adreslerini Al",
    "desc_tr": "Çoklu ağ kartına sahip cihazlarda aktif IP bağlarını listeler",
    "desc_en": "List active IP bindings on multi-homed machines"
  },
  {
    "key": "b_serverinstance_permission_list",
    "tr": "ServerQuery: Yetki Listesini Al",
    "desc_tr": "Sunucu örneğinde mevcut olan yetkileri listeler",
    "desc_en": "List permissions available available on the server instance"
  },
  {
    "key": "b_serverinstance_permission_find",
    "tr": "ServerQuery: Verilen Yetkileri Bul",
    "desc_tr": "Yetki atamalarını ad veya ID’ye göre arar",
    "desc_en": "Search permission assignments by name or ID"
  },
  {
    "key": "b_virtualserver_create",
    "tr": "ServerQuery: Sunucu Oluştur",
    "desc_tr": "Sanal sunucular oluşturur",
    "desc_en": "Create virtual servers"
  },
  {
    "key": "b_virtualserver_delete",
    "tr": "ServerQuery: Mevcut Sunucuyu Sil",
    "desc_tr": "Sanal sunucuları siler",
    "desc_en": "Delete virtual servers"
  },
  {
    "key": "b_virtualserver_start_any",
    "tr": "ServerQuery: Sunucuları Başlat",
    "desc_tr": "Sunucu örneğindeki herhangi bir sanal sunucuyu başlatır",
    "desc_en": "Start any virtual server in the server instance"
  },
  {
    "key": "b_virtualserver_stop_any",
    "tr": "ServerQuery: Sunucuları Durdur",
    "desc_tr": "Sunucu örneğindeki herhangi bir sanal sunucuyu durdurur",
    "desc_en": "Stop any virtual server in the server instance"
  },
  {
    "key": "b_virtualserver_change_machine_id",
    "tr": "Sunucu Makine ID Düzenle",
    "desc_tr": "Bir sanal sunucunun makine kimliğini (Machine ID) değiştirir",
    "desc_en": "Change a virtual servers machine ID"
  },
  {
    "key": "b_virtualserver_change_template",
    "tr": "ServerQuery: Sunucu Şablonu Düzenle",
    "desc_tr": "Sanal sunucu varsayılan şablon değerlerini düzenler",
    "desc_en": "Edit virtual server default template values"
  },
  {
    "key": "b_serverquery_login",
    "tr": "ServerQuery: ServerQuery ile Giriş",
    "desc_tr": "ServerQuery’e giriş yapar",
    "desc_en": "Login to ServerQuery"
  },
  {
    "key": "b_serverquery_login_create",
    "tr": "ServerQuery Girişi Oluştur",
    "desc_tr": "Yeni bir ServerQuery girişi oluşturur",
    "desc_en": "Create a new server query login"
  },
  {
    "key": "b_serverquery_login_delete",
    "tr": "ServerQuery Girişini Sil",
    "desc_tr": "Bir ServerQuery girişini siler",
    "desc_en": "Delete a server query login"
  },
  {
    "key": "b_serverquery_login_list",
    "tr": "ServerQuery Girişlerini Listele",
    "desc_tr": "ServerQuery girişlerini listeler",
    "desc_en": "List server query logins"
  },
  {
    "key": "b_serverinstance_textmessage_send",
    "tr": "ServerQuery: Sunucu ve diğer herkese mesaj gönder",
    "desc_tr": "Tüm sanal sunuculara tek seferde metin mesajı gönderir",
    "desc_en": "Send text messages to all virtual servers at once"
  },
  {
    "key": "b_serverinstance_log_view",
    "tr": "ServerQuery: Sunucu Durum Kayıtları Görüntüle",
    "desc_tr": "Genel sunucu günlüklerini alır",
    "desc_en": "Retrieve global server log"
  },
  {
    "key": "b_serverinstance_log_add",
    "tr": "ServerQuery: Sunucuya Durum Kayıtları Yaz",
    "desc_tr": "Genel sunucu günlüğüne yazar",
    "desc_en": "Write to global server log"
  },
  {
    "key": "b_serverinstance_stop",
    "tr": "ServerQuery: Sunucu Durumunu Durdur",
    "desc_tr": "Sunucu sürecini kapatır",
    "desc_en": "Shutdown the server process"
  },
  {
    "key": "b_serverinstance_modify_settings",
    "tr": "ServerQuery: Sunucu Durum Ayarlarını Düzenle",
    "desc_tr": "Genel ayarları düzenler",
    "desc_en": "Edit global settings"
  },
  {
    "key": "b_serverinstance_modify_querygroup",
    "tr": "ServerQuery Gruplarını Düzenle",
    "desc_tr": "Genel ServerQuery gruplarını düzenler",
    "desc_en": "Edit global ServerQuery groups"
  },
  {
    "key": "b_serverinstance_modify_templates",
    "tr": "Şablon Grupları Düzenle",
    "desc_tr": "Genel şablon gruplarını düzenler",
    "desc_en": "Edit global template groups"
  },
  {
    "key": "b_virtualserver_select",
    "tr": "ServerQuery: Sunucu Seç",
    "desc_tr": "Bir sanal sunucu seçer",
    "desc_en": "Select a virtual server"
  },
  {
    "key": "b_virtualserver_info_view",
    "tr": "ServerQuery: Sunucu Bilgisini Görüntüle",
    "desc_tr": "Sanal sunucu bilgilerini alır",
    "desc_en": "Retrieve virtual server information"
  },
  {
    "key": "b_virtualserver_connectioninfo_view",
    "tr": "Sunucu Bağlantı Bilgisini Görüntüle",
    "desc_tr": "Sanal sunucu bağlantı bilgilerini alır",
    "desc_en": "Retrieve virtual server connection information"
  },
  {
    "key": "b_virtualserver_channel_list",
    "tr": "ServerQuery: Mevcut Kanal Listesini Görüntüle",
    "desc_tr": "Sanal sunucudaki kanalları listeler",
    "desc_en": "List channels on a virtual server"
  },
  {
    "key": "b_virtualserver_channel_search",
    "tr": "ServerQuery: Kanallarda Ara",
    "desc_tr": "Sanal sunucudaki kanalları arar",
    "desc_en": "Search for channels on a virtual server"
  },
  {
    "key": "b_virtualserver_client_list",
    "tr": "ServerQuery: Çevrimiçi Kullanıcı Listesini Görüntüle",
    "desc_tr": "Sanal sunucuda çevrimiçi olan kullanıcıları listeler",
    "desc_en": "List clients online on a virtual server"
  },
  {
    "key": "b_virtualserver_client_search",
    "tr": "ServerQuery: Çevrimiçi Kullanıcılarda Ara",
    "desc_tr": "Sanal sunucuda çevrimiçi kullanıcıları arar",
    "desc_en": "Search for clients online on a virtual server"
  },
  {
    "key": "b_virtualserver_client_dblist",
    "tr": "Veritabanında Bulunan Bilinen Kullanıcı Kimliklerini Görüntüle",
    "desc_tr": "Sanal sunucu tarafından bilinen kullanıcı kimliklerini listeler",
    "desc_en": "List client identities known by the virtual server"
  },
  {
    "key": "b_virtualserver_client_dbsearch",
    "tr": "Veritabanında Bulunan Bilinen Kullanıcı Kimliklerinde Ara",
    "desc_tr": "Sanal sunucu tarafından bilinen kullanıcı kimliklerini arar",
    "desc_en": "Search for client identities known by the virtual server"
  },
  {
    "key": "b_virtualserver_client_dbinfo",
    "tr": "ServerQuery: Kullanıcı Veritabanı Açıklamasını Görüntüle",
    "desc_tr": "Kullanıcı bilgilerini alır",
    "desc_en": "Retrieve client information"
  },
  {
    "key": "b_virtualserver_permission_find",
    "tr": "ServerQuery: Yetki Atamalarında Ara",
    "desc_tr": "Yetkileri bulur",
    "desc_en": "Find permissions"
  },
  {
    "key": "b_virtualserver_custom_search",
    "tr": "ServerQuery: Özel Kullanıcı Özelliklerinde Ara",
    "desc_tr": "Özel alanları bulur",
    "desc_en": "Find custom fields"
  },
  {
    "key": "b_virtualserver_start",
    "tr": "ServerQuery: Bu Sunucuyu Başlat",
    "desc_tr": "Kendi sanal sunucunu başlatır",
    "desc_en": "Start own virtual server"
  },
  {
    "key": "b_virtualserver_stop",
    "tr": "ServerQuery: Bu Sunucuyu Durdur",
    "desc_tr": "Kendi sanal sunucunu durdurur",
    "desc_en": "Stop own virtual server"
  },
  {
    "key": "b_virtualserver_token_list",
    "tr": "Yetki Kodu Listesini Görüntüle",
    "desc_tr": "Mevcut yetki kodlarını listeler",
    "desc_en": "List privilege keys available"
  },
  {
    "key": "b_virtualserver_token_add",
    "tr": "Yetki Kodu Oluştur",
    "desc_tr": "Yeni yetki kodları oluşturur",
    "desc_en": "Create new privilege keys"
  },
  {
    "key": "b_virtualserver_token_use",
    "tr": "Yetki Kodu Kullan",
    "desc_tr": "Gruplara erişim sağlamak için yetki kodu kullanır",
    "desc_en": "Use a privilege keys to gain access to groups"
  },
  {
    "key": "b_virtualserver_token_delete",
    "tr": "Yetki Kodu Sil",
    "desc_tr": "Bir yetki kodunu siler",
    "desc_en": "Delete a privilege key"
  },
  {
    "key": "b_virtualserver_apikey_add",
    "tr": "Sanal Sunucu API Anahtarı Ekle",
    "desc_tr": "Yeni bir API anahtarı oluşturur",
    "desc_en": "Create a new API key"
  },
  {
    "key": "b_virtualserver_apikey_manage",
    "tr": "**Sanal Sunucu API Anahtarlarını Yönet",
    "desc_tr": "Mevcut API anahtarlarını yönetir",
    "desc_en": "Manage existing API keys"
  },
  {
    "key": "b_virtualserver_log_view",
    "tr": "ServerQuery: Sunucu Kaydını Görüntüle",
    "desc_tr": "Sanal sunucu günlüklerini alır",
    "desc_en": "Retrieve virtual server log"
  },
  {
    "key": "b_virtualserver_log_add",
    "tr": "ServerQuery: Sunucu Kaydı Yaz",
    "desc_tr": "Sanal sunucu günlüğüne yazar",
    "desc_en": "Write to virtual server log"
  },
  {
    "key": "b_virtualserver_join_ignore_password",
    "tr": "Sunucu Parolasını Yoksay",
    "desc_tr": "Şifresini yok sayarak sanal sunucuya bağlanır",
    "desc_en": "Join virtual server ignoring its password"
  },
  {
    "key": "b_virtualserver_notify_register",
    "tr": "ServerQuery: Sunucu Bildirimi İçin Abone Ol",
    "desc_tr": "Sunucu bildirimlerine abone olur",
    "desc_en": "Register for server notifications"
  },
  {
    "key": "b_virtualserver_notify_unregister",
    "tr": "ServerQuery: Sunucu Bildirim Aboneliği Kaldır",
    "desc_tr": "Sunucu bildirim aboneliğini kaldırır",
    "desc_en": "Unregister from server notifications"
  },
  {
    "key": "b_virtualserver_snapshot_create",
    "tr": "ServerQuery: Sunucu Ayarlarına Geri Dön",
    "desc_tr": "Sunucu anlık görüntülerini oluşturur",
    "desc_en": "Create server snapshots"
  },
  {
    "key": "b_virtualserver_snapshot_deploy",
    "tr": "ServerQuery: Sunucu Ayarlarını Koru",
    "desc_tr": "Sunucu anlık görüntülerini uygular",
    "desc_en": "Deploy server snapshots"
  },
  {
    "key": "b_virtualserver_permission_reset",
    "tr": "ServerQuery: Sunucu Yetki Ayarlarını Sıfırla",
    "desc_tr": "Sunucu yetki ayarlarını varsayılan değerlere sıfırlar",
    "desc_en": "Reset the server permission settings to default values"
  },
  {
    "key": "b_virtualserver_modify_name",
    "tr": "Sunucu Adını Düzenle",
    "desc_tr": "Sunucu adını değiştirir",
    "desc_en": "Modify server name"
  },
  {
    "key": "b_virtualserver_modify_welcomemessage",
    "tr": "Sunucu Hoşgeldin Mesajını Düzenle",
    "desc_tr": "Karşılama mesajını değiştirir",
    "desc_en": "Modify welcome message"
  },
  {
    "key": "b_virtualserver_modify_maxclients",
    "tr": "Sunucunun Maks.Kullanıcı Sayısını Düzenle",
    "desc_tr": "Sunucunun maksimum kullanıcı sayısını değiştirir",
    "desc_en": "Modify servers max clients"
  },
  {
    "key": "b_virtualserver_modify_reserved_slots",
    "tr": "Sunucunun Maks.Kullanıcı Sayısını Geçmeden Düzenle",
    "desc_tr": "Rezerve slot sayısını değiştirir",
    "desc_en": "Modify reserved slots"
  },
  {
    "key": "b_virtualserver_modify_password",
    "tr": "Sunucu Parolasını Düzenle",
    "desc_tr": "Sunucu şifresini değiştirir",
    "desc_en": "Modify server password"
  },
  {
    "key": "b_virtualserver_modify_default_servergroup",
    "tr": "Sunucunun Standart Sunucu Grubunu Düzenle",
    "desc_tr": "Varsayılan Sunucu Grubunu değiştirir",
    "desc_en": "Modify default Server Group"
  },
  {
    "key": "b_virtualserver_modify_default_channelgroup",
    "tr": "Sunucunun Standart Kanal Grubunu Düzenle",
    "desc_tr": "Varsayılan Kanal Grubunu değiştirir",
    "desc_en": "Modify default Channel Group"
  },
  {
    "key": "b_virtualserver_modify_default_channeladmingroup",
    "tr": "Sunucunun Kanal Yetkilisi Grubunu Düzenle",
    "desc_tr": "Varsayılan Kanal Yönetici Grubunu değiştirir",
    "desc_en": "Modify default Channel Admin Group"
  },
  {
    "key": "b_virtualserver_modify_channel_forced_silence",
    "tr": "Sunucu Kuvvetli Sessizlik Limitini Düzenle",
    "desc_tr": "Kanal zorunlu susturma değerini değiştirir",
    "desc_en": "Modify channel force silence value"
  },
  {
    "key": "b_virtualserver_modify_complain",
    "tr": "Sunucu Şikayet Ayarlarını Düzenle",
    "desc_tr": "Sunucu şikayet ayarlarını değiştirir",
    "desc_en": "Modify individual complain settings"
  },
  {
    "key": "b_virtualserver_modify_antiflood",
    "tr": "Sunucu Anti-Flood Ayarlarını Düzenle",
    "desc_tr": "Sunucu antiflood ayarlarını değiştirir",
    "desc_en": "Modify individual antiflood settings"
  },
  {
    "key": "b_virtualserver_modify_ft_settings",
    "tr": "Sunucunun Dosya Transfer Ayarını Düzenle",
    "desc_tr": "Dosya aktarım ayarlarını değiştirir",
    "desc_en": "Modify file transfer settings"
  },
  {
    "key": "b_virtualserver_modify_ft_quotas",
    "tr": "Sunucunun Dosya Transfer Kotasını Düzenle",
    "desc_tr": "Dosya aktarım kotalarını değiştirir",
    "desc_en": "Modify file transfer quotas"
  },
  {
    "key": "b_virtualserver_modify_hostmessage",
    "tr": "Sunucu Host Mesajını Düzenle",
    "desc_tr": "Sunucu host mesajı ayarlarını değiştirir",
    "desc_en": "Modify individual hostmessage settings"
  },
  {
    "key": "b_virtualserver_modify_hostbanner",
    "tr": "Sunucu Host Resmini  Düzenle",
    "desc_tr": "Sunucu host banner ayarlarını değiştirir",
    "desc_en": "Modify individual hostbanner settings"
  },
  {
    "key": "b_virtualserver_modify_hostbutton",
    "tr": "Sunucu Host Butonunu Düzenle",
    "desc_tr": "Sunucu host butonu ayarlarını değiştirir",
    "desc_en": "Modify individual hostbutton settings"
  },
  {
    "key": "b_virtualserver_modify_port",
    "tr": "Sunucu Port Düzenle",
    "desc_tr": "Sunucu Portunu Düzenler",
    "desc_en": "Modify server port"
  },
  {
    "key": "b_virtualserver_modify_autostart",
    "tr": "Sunucu Otomatik Başlama Ayarını Düzenle",
    "desc_tr": "Sunucu otomatik başlatmayı değiştirir",
    "desc_en": "Modify server autostart"
  },
  {
    "key": "b_virtualserver_modify_needed_identity_security_level",
    "tr": "Sunucu Güvenlik Seviyesini Düzenle",
    "desc_tr": "Gerekli kimlik güvenlik seviyesini değiştirir",
    "desc_en": "Modify required identity security level"
  },
  {
    "key": "b_virtualserver_modify_priority_speaker_dimm_modificator",
    "tr": "Sunucu Önceliği Dimm Modificatör Pluginini Düzenle",
    "desc_tr": "Öncelikli konuşmacı kısma azaltma değiştirir",
    "desc_en": "Modify priority speaker dimm modificator"
  },
  {
    "key": "b_virtualserver_modify_log_settings",
    "tr": "Sunucu Kayıt Tutma Ayarlarını Düzenle",
    "desc_tr": "Günlük ayarlarını değiştirir",
    "desc_en": "Modify log settings"
  },
  {
    "key": "b_virtualserver_modify_min_client_version",
    "tr": "Sunucu için Gereken Minimum Kullanıcı Versiyonunu Düzenle",
    "desc_tr": "Minimum kullanıcı sürümünü değiştirir",
    "desc_en": "Modify min client version"
  },
  {
    "key": "b_virtualserver_modify_icon_id",
    "tr": "Sunucu İkonunu Düzenle",
    "desc_tr": "Sunucu ikonunu değiştirir",
    "desc_en": "Modify server icon"
  },
  {
    "key": "b_virtualserver_modify_weblist",
    "tr": "Sunucunun WebListesindeki Duyurularını Düzenle",
    "desc_tr": "Web sunucu listesi bildirim ayarlarını değiştirir",
    "desc_en": "Modify web server list reporting settings"
  },
  {
    "key": "b_virtualserver_modify_codec_encryption_mode",
    "tr": "Sunucu Ses Ayarını Düzenle",
    "desc_tr": "Codec şifreleme modunu değiştirir",
    "desc_en": "Modify codec encryption mode"
  },
  {
    "key": "b_virtualserver_modify_temporary_passwords",
    "tr": "Geçici Sunucu Parolalarını Düzenle",
    "desc_tr": "Geçici sunucu parolalarını değiştirir",
    "desc_en": "Modify temporary serverpasswords"
  },
  {
    "key": "b_virtualserver_modify_temporary_passwords_own",
    "tr": "Kendi Oluşturduğu Geçici Sunucu Parolalarını Düzenle",
    "desc_tr": "Kendi geçici sunucu parolalarını değiştirir",
    "desc_en": "Modify own temporary serverpasswords"
  },
  {
    "key": "b_virtualserver_modify_channel_temp_delete_delay_default",
    "tr": "Varsayılan Geçici Kanal Silme Gecikmesini Değiştir",
    "desc_tr": "Varsayılan geçici kanal silme gecikmesini değiştirir",
    "desc_en": "Modify default temporary channel delete delay"
  },
  {
    "key": "b_virtualserver_modify_nickname",
    "tr": "Sunucu Takma Adını Değiştir",
    "desc_tr": "Sunucu takma adlarını değiştirir",
    "desc_en": "Modify server nicknames"
  },
  {
    "key": "b_virtualserver_modify_integrations",
    "tr": "Sunucu entegrasyonlarını değiştiri",
    "desc_tr": "Entegrasyonları değiştirir",
    "desc_en": "Modify integrations"
  },
  {
    "key": "i_channel_min_depth",
    "tr": "Minimum Kanal Yoğunluğu",
    "desc_tr": "Kanal hiyerarşisinde minimum oluşturma derinliği",
    "desc_en": "Min channel creation depth in hierarchy"
  },
  {
    "key": "i_channel_max_depth",
    "tr": "Maksimum Kanal Yoğunluğu",
    "desc_tr": "Kanal hiyerarşisinde maksimum oluşturma derinliği",
    "desc_en": "Max channel creation depth in hierarchy"
  },
  {
    "key": "b_channel_group_inheritance_end",
    "tr": "Alt kanal olma",
    "desc_tr": "Kanal grup yetkilerinin devralınmasını durdurur",
    "desc_en": "Stop inheritance of channel group permissions"
  },
  {
    "key": "i_channel_permission_modify_power",
    "tr": "Kanal Düzenleme Gücü",
    "desc_tr": "Kanal yetki gücünü değiştirir",
    "desc_en": "Modify channel permission power"
  },
  {
    "key": "i_channel_needed_permission_modify_power",
    "tr": "Gereken Kanal Yetkisi Düzenleme Gücü",
    "desc_tr": "Kanal yetki gücünü değiştirmek için gerekli yetki gücü",
    "desc_en": "Needed modify channel permission power"
  },
  {
    "key": "b_channel_info_view",
    "tr": "ServerQuery: Kanal Açıklamasını Görüntüle",
    "desc_tr": "Kanal bilgilerini alır",
    "desc_en": "Retrieve channel information"
  },
  {
    "key": "b_channel_create_child",
    "tr": "Alt Kanal Oluşturma",
    "desc_tr": "Alt kanallar oluşturur",
    "desc_en": "Create sub-channels"
  },
  {
    "key": "b_channel_create_permanent",
    "tr": "Kalıcı Kanal Oluştur",
    "desc_tr": "Kalıcı kanallar oluşturur",
    "desc_en": "Create permanent channels"
  },
  {
    "key": "b_channel_create_semi_permanent",
    "tr": "Yarı-Kalıcı Kanal Oluştur",
    "desc_tr": "Yarı kalıcı kanallar oluşturur",
    "desc_en": "Create semi-permanent channels"
  },
  {
    "key": "b_channel_create_temporary",
    "tr": "Geçici Kanal Oluştur",
    "desc_tr": "Geçici kanallar oluşturur",
    "desc_en": "Create temporary channels"
  },
  {
    "key": "b_channel_create_with_topic",
    "tr": "Başlık ile Kanal Oluştur",
    "desc_tr": "Başlık içeren kanallar oluşturun",
    "desc_en": "Create channels with a topic"
  },
  {
    "key": "b_channel_create_with_description",
    "tr": "Açıklama ile Kanal Oluştur",
    "desc_tr": "Açıklama içeren kanallar oluşturun.",
    "desc_en": "Create channels with a description"
  },
  {
    "key": "b_channel_create_with_password",
    "tr": "Parola ile Kanal Oluştur",
    "desc_tr": "Parola korumalı kanallar oluşturun",
    "desc_en": "Create password protected channels"
  },
  {
    "key": "b_channel_create_with_banner",
    "tr": "Kanal Banner ile Kanal Oluştur",
    "desc_tr": "Afişli kanal oluşturur",
    "desc_en": "Create channel with a banner"
  },
  {
    "key": "b_channel_create_modify_with_codec_opusvoice",
    "tr": "Opus Ses kodeği ile Kanal Düzenler",
    "desc_tr": "OPUS (ses) kodeğini kullanarak kanallar oluşturun.",
    "desc_en": "Create channels using OPUS (voice) codec"
  },
  {
    "key": "b_channel_create_modify_with_codec_opusmusic",
    "tr": "Opus Müzik kodeği ile Kanal Düzenler",
    "desc_tr": "OPUS (müzik) kodeğini kullanarak kanallar oluşturun.",
    "desc_en": "Create channels using OPUS (music) codec"
  },
  {
    "key": "i_channel_create_modify_with_codec_maxquality",
    "tr": "Kanalı Ses Kalitesi Ayarı İle Oluştur ve Düzenle",
    "desc_tr": "Özel kodek kalitesine sahip kanallar oluşturun.",
    "desc_en": "Create channels with custom codec quality"
  },
  {
    "key": "i_channel_create_modify_with_codec_latency_factor_min",
    "tr": "Kanalı Minimum Ses Gecikme Faktörü ile Oluştur ve Düzenle",
    "desc_tr": "Minimum özel kodek gecikme faktörüyle kanallar oluşturun.",
    "desc_en": "Create channels with minimal custom codec latency factor"
  },
  {
    "key": "b_channel_create_with_maxclients",
    "tr": "Maks.Kullanıcı Ayarı ile Kanal Oluştur",
    "desc_tr": "Özel maksimum kullanıcı sayısına sahip kanallar oluşturun.",
    "desc_en": "Create channels with custom max clients"
  },
  {
    "key": "b_channel_create_with_maxfamilyclients",
    "tr": "Aile Maks.Kullanıcı Ayarı ile Kanal Oluştur",
    "desc_tr": "Özel maksimum aile kullanıcı sayısıyla kanallar oluşturur",
    "desc_en": "Create channels with custom max family clients"
  },
  {
    "key": "b_channel_create_with_sortorder",
    "tr": "Kanal Sıralaması Ayarı ile Kanal Oluştur",
    "desc_tr": "Özel sıralama düzenine sahip kanallar oluşturun.",
    "desc_en": "Create channels with custom sort order"
  },
  {
    "key": "b_channel_create_with_default",
    "tr": "Standart Kanal Ayarı ile Kanal Oluştur",
    "desc_tr": "Varsayılan kanallar oluştur",
    "desc_en": "Create default channels"
  },
  {
    "key": "b_channel_create_with_needed_talk_power",
    "tr": "Gereken Konuşma Gücü Ayarı ile Kanal Oluştur",
    "desc_tr": "Gerekli konuşma gücüne sahip kanallar oluşturun.",
    "desc_en": "Create channels with needed talk power"
  },
  {
    "key": "b_channel_create_modify_with_force_password",
    "tr": "Kanalı Zorunlu Olarak Parola ile Oluştur",
    "desc_tr": "Yeni kanallar yalnızca şifreyle oluşturulabilir.",
    "desc_en": "Create new channels only with password"
  },
  {
    "key": "i_channel_create_modify_with_temp_delete_delay",
    "tr": "Geçici silme gecikmesiyle kanal oluşturur veya değiştirir",
    "desc_tr": "Geçici kanallar için maksimum silme gecikmesi",
    "desc_en": "Max delete delay for temporary channels"
  },
  {
    "key": "b_channel_modify_parent",
    "tr": "Kanalları Taşı",
    "desc_tr": "Kanalları Taşır",
    "desc_en": "Move channels"
  },
  {
    "key": "b_channel_modify_make_default",
    "tr": "Standart Kanal Ayarını düzenle",
    "desc_tr": "Kanalı varsayılan yap",
    "desc_en": "Make channel default"
  },
  {
    "key": "b_channel_modify_make_permanent",
    "tr": "Kanalı Kalıcı Olarak Değiştir",
    "desc_tr": "Kanalı kalıcı hale getir",
    "desc_en": "Make channel permanent"
  },
  {
    "key": "b_channel_modify_make_semi_permanent",
    "tr": "Kanalı Yarı-Kalıcı Olarak Değiştir",
    "desc_tr": "Kanalı yarı kalıcı hale getirin",
    "desc_en": "Make channel semi-permanent"
  },
  {
    "key": "b_channel_modify_make_temporary",
    "tr": "Kanalı Geçici Olarak Değiştir",
    "desc_tr": "Kanalı geçici yap",
    "desc_en": "Make channel temporary"
  },
  {
    "key": "b_channel_modify_name",
    "tr": "Kanal İsmini Düzenle",
    "desc_tr": "Kanal İsmini Düzenle",
    "desc_en": "Modify channel name"
  },
  {
    "key": "b_channel_modify_topic",
    "tr": "Kanal Başlığını Düzenle",
    "desc_tr": "Kanal Başlığını Düzenle",
    "desc_en": "Modify channel topic"
  },
  {
    "key": "b_channel_modify_description",
    "tr": "Kanal Açıklamasını Düzenle",
    "desc_tr": "Kanal Açıklamasını Düzenle",
    "desc_en": "Modify channel description"
  },
  {
    "key": "b_channel_modify_password",
    "tr": "Kanal Parolasını Düzenle",
    "desc_tr": "Kanal Parolasını Düzenle",
    "desc_en": "Modify channel password"
  },
  {
    "key": "b_channel_modify_banner",
    "tr": "Kanal Banner Düzenle",
    "desc_tr": "Kanal Banner Düzenle",
    "desc_en": "Modify channel banner"
  },
  {
    "key": "b_channel_modify_codec",
    "tr": "Kanal Ses Bandı Ayarını Düzenle",
    "desc_tr": "Kanal codec'ini değiştir",
    "desc_en": "Modify channel codec"
  },
  {
    "key": "b_channel_modify_codec_quality",
    "tr": "Kanal Ses Kalitesini Düzenle",
    "desc_tr": "Kanal kodek kalitesini değiştirin",
    "desc_en": "Modify channel codec quality"
  },
  {
    "key": "b_channel_modify_codec_latency_factor",
    "tr": "Kanal Ses Gecikme Ayarını Düzenle",
    "desc_tr": "Kanal kodek gecikme faktörünü değiştirin",
    "desc_en": "Modify channel codec latency factor"
  },
  {
    "key": "b_channel_modify_maxclients",
    "tr": "Kanal Maks.Kullanıcı Ayarını Düzenle",
    "desc_tr": "Kanalların maksimum kullanıcı sayısını değiştirin.",
    "desc_en": "Modify channels max clients"
  },
  {
    "key": "b_channel_modify_maxfamilyclients",
    "tr": "Kanal Aile Maks.Kullanıcı Ayarını Düzenle",
    "desc_tr": "Kanalların maksimum aile kullanıcı sayısını değiştirir",
    "desc_en": "Modify channels max family clients"
  },
  {
    "key": "b_channel_modify_sortorder",
    "tr": "Kanal Sıralaması Ayarını Düzenle",
    "desc_tr": "Kanal sıralama düzenini değiştir",
    "desc_en": "Modify channel sort order"
  },
  {
    "key": "b_channel_modify_needed_talk_power",
    "tr": "Kanal Gerekli Konuşma Gücü Ayarını Düzenle",
    "desc_tr": "Gerekli kanal konuşma gücünü değiştirir",
    "desc_en": "Change needed channel talk power"
  },
  {
    "key": "i_channel_modify_power",
    "tr": "Kanal Düzenleme Gücü",
    "desc_tr": "Kanal düzenleme gücü",
    "desc_en": "Channel modify power"
  },
  {
    "key": "i_channel_needed_modify_power",
    "tr": "Gereken Kanal Düzenleme Gücü",
    "desc_tr": "Gerekli kanal düzenleme gücü",
    "desc_en": "Needed channel modify power"
  },
  {
    "key": "b_channel_modify_make_codec_encrypted",
    "tr": "Kanal Ses Ayarını Düzenle",
    "desc_tr": "Kanal codec'ini şifreleyin.",
    "desc_en": "Make channel codec encrypted"
  },
  {
    "key": "b_channel_modify_temp_delete_delay",
    "tr": "Geçici Kanal Silme Gecikmesini Değiştir",
    "desc_tr": "Geçici kanal silme gecikmesini değiştirir",
    "desc_en": "Modify temporary channel delete delay"
  },
  {
    "key": "b_channel_delete_permanent",
    "tr": "Kalıcı Kanalı Sil",
    "desc_tr": "Kalıcı kanalları siler",
    "desc_en": "Delete permanent channels"
  },
  {
    "key": "b_channel_delete_semi_permanent",
    "tr": "Yarı-Kalıcı Kanalı Sil",
    "desc_tr": "Yarı kalıcı kanalları siler",
    "desc_en": "Delete semi-permanent channels"
  },
  {
    "key": "b_channel_delete_temporary",
    "tr": "Geçici Kanalı Sil",
    "desc_tr": "Geçici kanalları siler",
    "desc_en": "Delete temporary channels"
  },
  {
    "key": "b_channel_delete_flag_force",
    "tr": "Kanalı Alt Odalarıyla Birlikte Sil",
    "desc_tr": "Kanal silmeye zorla",
    "desc_en": "Force channel delete"
  },
  {
    "key": "i_channel_delete_power",
    "tr": "Kanal Silme Gücü",
    "desc_tr": "Kanal Silme Gücü",
    "desc_en": "Delete channel power"
  },
  {
    "key": "i_channel_needed_delete_power",
    "tr": "Gereken Kanal Silme Gücü",
    "desc_tr": "Gereken Kanal Silme Gücü",
    "desc_en": "Needed delete channel power"
  },
  {
    "key": "b_channel_join_permanent",
    "tr": "Kalıcı Kanallara Giriş",
    "desc_tr": "Kalıcı kanallara katılır",
    "desc_en": "Join permanent channels"
  },
  {
    "key": "b_channel_join_semi_permanent",
    "tr": "Yarı-Kalıcı Kanallara Giriş",
    "desc_tr": "Yarı kalıcı kanallara katılır",
    "desc_en": "Join semi-permanent channels"
  },
  {
    "key": "b_channel_join_temporary",
    "tr": "Geçici Kanallara Giriş",
    "desc_tr": "Geçici kanallara katılır",
    "desc_en": "Join temporary channels"
  },
  {
    "key": "b_channel_join_ignore_password",
    "tr": "Kanal Parolasını Yoksay",
    "desc_tr": "Kanal şifresini yok sayarak kanala katılır",
    "desc_en": "Join channel ignoring its password"
  },
  {
    "key": "b_channel_join_ignore_maxclients",
    "tr": "Kanal Maks.Kullanıcı Ayarını Yoksay",
    "desc_tr": "Kanalın maksimum kullanıcı sınırını yok sayar",
    "desc_en": "Ignore channels max clients limit"
  },
  {
    "key": "i_channel_join_power",
    "tr": "Kanal Giriş Gücü",
    "desc_tr": "Kanal Giriş Gücü",
    "desc_en": "Channel join power"
  },
  {
    "key": "i_channel_needed_join_power",
    "tr": "Gereken Kanal Giriş Gücü",
    "desc_tr": "Gerekli kanala giriş gücü",
    "desc_en": "Needed channel join power"
  },
  {
    "key": "i_channel_subscribe_power",
    "tr": "Kanal Görüntüleme Gücü",
    "desc_tr": "Kanal Görüntüleme Gücü",
    "desc_en": "Channel subscribe power"
  },
  {
    "key": "i_channel_needed_subscribe_power",
    "tr": "Gereken Kanal Görüntüleme Gücü",
    "desc_tr": "Gereken Kanalı Görüntüleme Gücü",
    "desc_en": "Needed channel subscribe power"
  },
  {
    "key": "i_channel_description_view_power",
    "tr": "Kanal Açıklaması Görüntüleme Gücü",
    "desc_tr": "Kanal açıklamasını görüntüleme gücü",
    "desc_en": "Channel description view power"
  },
  {
    "key": "i_channel_needed_description_view_power",
    "tr": "Gereken Kanal Açıklama Gücü",
    "desc_tr": "Gerekli kanal açıklamasını görüntüleme gücü",
    "desc_en": "Needed channel needed description view power"
  },
  {
    "key": "i_icon_id",
    "tr": "İkon ID",
    "desc_tr": "Grup ikon tanımlayıcısı",
    "desc_en": "Group icon identifier"
  },
  {
    "key": "i_max_icon_filesize",
    "tr": "Maks.İkon Boyutu(Byte)",
    "desc_tr": "Bayt cinsinden maksimum simge dosya boyutu",
    "desc_en": "Max icon filesize in bytes"
  },
  {
    "key": "b_icon_manage",
    "tr": "İkonları düzenle",
    "desc_tr": "İkon yönetimini etkinleştirir",
    "desc_en": "Enables icon management"
  },
  {
    "key": "b_group_is_permanent",
    "tr": "Grup Kalıcı",
    "desc_tr": "Grup kalıcıdır",
    "desc_en": "Group is permanent"
  },
  {
    "key": "i_group_auto_update_type",
    "tr": "Grup Otomatik Güncelleme Türü",
    "desc_tr": "Grup otomatik güncelleme türü",
    "desc_en": "Group auto-update type"
  },
  {
    "key": "i_group_auto_update_max_value",
    "tr": "Grup Otomatik Güncelleme Maks.Değeri",
    "desc_tr": "Grup otomatik güncelleme maksimum değeri",
    "desc_en": "Group auto-update max value"
  },
  {
    "key": "i_group_sort_id",
    "tr": "Grup Sıralama ID",
    "desc_tr": "Grup Sıralama ID",
    "desc_en": "Group sort id"
  },
  {
    "key": "i_group_show_name_in_tree",
    "tr": "Grubu İsmini Göster",
    "desc_tr": "Seçilen moda bağlı olarak ağaç yapısında grup adını göster",
    "desc_en": "Show group name in tree depending on selected mode"
  },
  {
    "key": "b_virtualserver_servergroup_list",
    "tr": "ServerQuery: Sunucu Grubu Listesini Görüntüle",
    "desc_tr": "Sunucu gruplarını listeler",
    "desc_en": "List server groups"
  },
  {
    "key": "b_virtualserver_servergroup_permission_list",
    "tr": "Sunucu Grubu Yetkileri Listesini Görüntüle",
    "desc_tr": "Sunucu grubu yetkilerini listeler",
    "desc_en": "List server group permissions"
  },
  {
    "key": "b_virtualserver_servergroup_client_list",
    "tr": "Sunucu Grubu Üyelerini Görüntüle",
    "desc_tr": "Bir sunucu grubundaki kullanıcıları listeler",
    "desc_en": "List clients from a server group"
  },
  {
    "key": "b_virtualserver_channelgroup_list",
    "tr": "ServerQuery: Kanal Grupları Listesini Görüntüle",
    "desc_tr": "Kanal gruplarını listeler",
    "desc_en": "List channel groups"
  },
  {
    "key": "b_virtualserver_channelgroup_permission_list",
    "tr": "Kanal Grubu Yetkileri Listesini Görüntüle",
    "desc_tr": "Kanal grubu yetkilerini listeler",
    "desc_en": "List channel group permissions"
  },
  {
    "key": "b_virtualserver_channelgroup_client_list",
    "tr": "Kanal Grubu Üyelerini Görüntüle",
    "desc_tr": "Bir kanal grubundaki kullanıcıları listeler",
    "desc_en": "List clients from a channel group"
  },
  {
    "key": "b_virtualserver_client_permission_list",
    "tr": "Kullanıcı Yetkileri Listesini Görüntüle",
    "desc_tr": "Kullanıcı yetkilerini listeler",
    "desc_en": "List client permissions"
  },
  {
    "key": "b_virtualserver_channel_permission_list",
    "tr": "Kanal Yetkileri Listesini Görüntüle",
    "desc_tr": "Kanal izinlerini listeleyin",
    "desc_en": "List channel permissions"
  },
  {
    "key": "b_virtualserver_channelclient_permission_list",
    "tr": "Kanal Kullanıcı Yetkileri Listesini Görüntüle",
    "desc_tr": "Kanal kullanıcı izinlerini listele",
    "desc_en": "List channel client permissions"
  },
  {
    "key": "b_virtualserver_servergroup_create",
    "tr": "Yeni Sunucu Grubu Oluştur",
    "desc_tr": "Sunucu grupları oluşturun",
    "desc_en": "Create server groups"
  },
  {
    "key": "b_virtualserver_channelgroup_create",
    "tr": "Yeni Kanal Grubu Oluştur",
    "desc_tr": "Kanal grupları oluşturun",
    "desc_en": "Create channel groups"
  },
  {
    "key": "i_group_modify_power",
    "tr": "Grup Düzenleme Gücü",
    "desc_tr": "Grup Düzenleme Gücü",
    "desc_en": "Group modify power"
  },
  {
    "key": "i_group_needed_modify_power",
    "tr": "Gereken Grup Düzenleme Gücü",
    "desc_tr": "Gerekli grup gücü değiştiriyor",
    "desc_en": "Needed group modify power"
  },
  {
    "key": "i_group_member_add_power",
    "tr": "Grubu Kullanıcıya Ekleme Gücü",
    "desc_tr": "Grup üyesi ekleme gücü",
    "desc_en": "Group member add power"
  },
  {
    "key": "i_group_needed_member_add_power",
    "tr": "Gereken Grubu Kullanıcıya Ekleme Gücü",
    "desc_tr": "Gerekli grup kullanıcı ekleme gücü",
    "desc_en": "Needed group member add power"
  },
  {
    "key": "i_group_member_remove_power",
    "tr": "Grubu Kullanıcıdan Kaldırma Gücü",
    "desc_tr": "Grup kullanıcı silme gücü",
    "desc_en": "Group member delete power"
  },
  {
    "key": "i_group_needed_member_remove_power",
    "tr": "Gereken Grubu Kullanıcıdan Kaldırma Gücü",
    "desc_tr": "Gerekli grup kullanıcı silme gücü",
    "desc_en": "Needed group member delete power"
  },
  {
    "key": "i_permission_modify_power",
    "tr": "Yetki Düzenleme Gücü",
    "desc_tr": "Yetki düzenleme gücü",
    "desc_en": "Permission modify power"
  },
  {
    "key": "b_permission_modify_power_ignore",
    "tr": "Yetki Düzenleme Gücünü Yoksay",
    "desc_tr": "Gerekli yetki düzenleme gücünü yok say",
    "desc_en": "Ignore needed permission modify power"
  },
  {
    "key": "b_virtualserver_servergroup_delete",
    "tr": "Sunucu Grubu Sil",
    "desc_tr": "Sunucu Grubu Siler",
    "desc_en": "Delete server groups"
  },
  {
    "key": "b_virtualserver_channelgroup_delete",
    "tr": "Kanal Grubu Sil",
    "desc_tr": "Kanal Grubu Siler",
    "desc_en": "Delete channel groups"
  },
  {
    "key": "i_client_permission_modify_power",
    "tr": "Kullanıcı Yetki Düzenleme Gücü",
    "desc_tr": "Kullanıcı yetkisi değiştirme gücü",
    "desc_en": "Client permission modify power"
  },
  {
    "key": "i_client_needed_permission_modify_power",
    "tr": "Gereken Kullanıcı Yetkisi Düzenleme Gücü",
    "desc_tr": "Gerekli kullanıcı yetkisi değiştirme gücü",
    "desc_en": "Needed client permission modify power"
  },
  {
    "key": "i_client_max_clones_uid",
    "tr": "Sunucuya Aynı Anda Maks.Giriş Sayısı",
    "desc_tr": "Kullanıcı kimliği başına maksimum ek bağlantı",
    "desc_en": "Max additional connections per client identity"
  },
  {
    "key": "i_client_max_idletime",
    "tr": "Maks.İşlemsiz Kalma (Saniye)",
    "desc_tr": "Maksimum boşta kalma süresi (saniye)",
    "desc_en": "Max idle time in seconds"
  },
  {
    "key": "i_client_max_avatar_filesize",
    "tr": "Maks.Avatar Boyutu(Byte)",
    "desc_tr": "Maksimum avatar dosya boyutu (bayt)",
    "desc_en": "Max avatar filesize in bytes"
  },
  {
    "key": "i_client_max_channel_subscriptions",
    "tr": "Maks.Kanal Görüntüleme",
    "desc_tr": "Maks.Kanal Görüntüleme",
    "desc_en": "Max channel subscriptions"
  },
  {
    "key": "b_client_is_priority_speaker",
    "tr": "Öncelik",
    "desc_tr": "Kullanıcı öncelikli konuşmacıdır",
    "desc_en": "Client is priority speaker"
  },
  {
    "key": "b_client_skip_channelgroup_permissions",
    "tr": "Kanal Grubu İzinlerini Geç",
    "desc_tr": "Kanal grubu yetkilerini yoksay",
    "desc_en": "Ignore channel group permissions"
  },
  {
    "key": "b_client_force_push_to_talk",
    "tr": "Bas-Konuş Zorunluluğu",
    "desc_tr": "Bas-Konuş yakalama modunu zorla",
    "desc_en": "Force Push-To-Talk capture mode"
  },
  {
    "key": "b_client_ignore_bans",
    "tr": "Banları Yoksay(Banlanmama)",
    "desc_tr": "Yasakları yoksay",
    "desc_en": "Ignore bans"
  },
  {
    "key": "b_client_ignore_antiflood",
    "tr": "Anti-Flood Ayarını Yoksay",
    "desc_tr": "Antiflood kısıtlamalarını yok say",
    "desc_en": "Ignore antiflood measurements"
  },
  {
    "key": "b_client_use_reserved_slot",
    "tr": "Maks.Kullanıcı Sayısını Geçmeden Düzenle",
    "desc_tr": "Ayrılmış slot kullan",
    "desc_en": "Use an reserved slot"
  },
  {
    "key": "b_client_use_channel_commander",
    "tr": "Kanal Komutçusu Ol",
    "desc_tr": "Kanal Komutçusu Ol",
    "desc_en": "Use channel commander"
  },
  {
    "key": "b_client_request_talker",
    "tr": "Konuşma Gücü Talebi İste",
    "desc_tr": "Konuşma yetkisi talep etmeye izin ver",
    "desc_en": "Allow to request talk power"
  },
  {
    "key": "b_client_avatar_delete_other",
    "tr": "Diğer Kullanıcı Avatarlarını Sil",
    "desc_tr": "Diğer kullanıcıların avatarlarını silmeye izin ver",
    "desc_en": "Allow deletion of avatars from other clients"
  },
  {
    "key": "b_client_is_sticky",
    "tr": "Sabit Kullanıcı",
    "desc_tr": "Kullanıcı mevcut kanala sabitlenir",
    "desc_en": "Client will be sticked to current channel"
  },
  {
    "key": "b_client_ignore_sticky",
    "tr": "Sabit Kullanıcı Yetkisini Yoksay",
    "desc_tr": "Kullanıcı sabitleme kuralını yok sayar",
    "desc_en": "Client ignores sticky flag"
  },
  {
    "key": "b_client_info_view",
    "tr": "ServerQuery: Kullanıcı Özelliklerini Görüntüle",
    "desc_tr": "Kullanıcı bilgilerini alır",
    "desc_en": "Retrieve client information"
  },
  {
    "key": "b_client_permissionoverview_view",
    "tr": "Kullanıcı İzinlerini Görüntüle",
    "desc_tr": "Kullanıcı İzinlerini Görüntüler",
    "desc_en": "Retrieve client permissions overview"
  },
  {
    "key": "b_client_permissionoverview_own",
    "tr": "Kendi Kullanıcı İzinini Görüntüle",
    "desc_tr": "Kendi Kullanıcı İzinini Görüntüler",
    "desc_en": "Retrieve clients own permissions overview"
  },
  {
    "key": "b_client_remoteaddress_view",
    "tr": "Kullanıcı IP Adresini Görüntüle",
    "desc_tr": "Kullanıcının IP adresini ve portunu görüntüler",
    "desc_en": "View client IP address and port"
  },
  {
    "key": "i_client_serverquery_view_power",
    "tr": "ServerQuery Kullanıcı Görüntüleme Gücü",
    "desc_tr": "ServerQuery görüntüleme yetkisini alır",
    "desc_en": "ServerQuery view power"
  },
  {
    "key": "i_client_needed_serverquery_view_power",
    "tr": "Gereken ServerQuery Kullanıcı Görüntüleme Gücü",
    "desc_tr": "Gerekli ServerQuery görüntüleme yetkisini alır",
    "desc_en": "Needed ServerQuery view power"
  },
  {
    "key": "b_client_custom_info_view",
    "tr": "ServerQuery: Özel Kullanıcı Özelliklerini Görüntüle",
    "desc_tr": "Özel Kullanıcı Özelliklerini görüntüler",
    "desc_en": "View custom fields"
  },
  {
    "key": "i_client_kick_from_server_power",
    "tr": "Sunucudan Kullanıcı Atma Gücü",
    "desc_tr": "Sunucudan kullanıcı atma gücü alır",
    "desc_en": "Client kick power from server"
  },
  {
    "key": "i_client_needed_kick_from_server_power",
    "tr": "Gereken Sunucudan Kullanıcı Atma Gücü",
    "desc_tr": "Sunucudan kullanıcı atmak için gerekli gücü alır",
    "desc_en": "Needed client kick power from server"
  },
  {
    "key": "i_client_kick_from_channel_power",
    "tr": "Kanaldan Kullanıcı Atma Gücü",
    "desc_tr": "Kanaldan kullanıcı atma gücünü alır",
    "desc_en": "Client kick power from channel"
  },
  {
    "key": "i_client_needed_kick_from_channel_power",
    "tr": "Gereken Kanaldan Kullanıcı Atma Gücü",
    "desc_tr": "Kanaldan kullanıcı atmak için gerekli gücü alır",
    "desc_en": "Needed client kick power from channel"
  },
  {
    "key": "i_client_ban_power",
    "tr": "Kullanıcı Banlama Gücü",
    "desc_tr": "Kullanıcı Banlama Gücü",
    "desc_en": "Client ban power"
  },
  {
    "key": "i_client_needed_ban_power",
    "tr": "Gereken Kullanıcı Banlama Gücü",
    "desc_tr": "Kullanıcıyı yasaklamak için gerekli gücü alır",
    "desc_en": "Needed client ban power"
  },
  {
    "key": "i_client_move_power",
    "tr": "Kullanıcı Taşıma Gücü",
    "desc_tr": "Kullanıcı Taşıma Gücü",
    "desc_en": "Client move power"
  },
  {
    "key": "i_client_needed_move_power",
    "tr": "Gereken Kullanıcı Taşıma Gücü",
    "desc_tr": "Kullanıcıyı taşımak için gerekli gücü alır",
    "desc_en": "Needed client move power"
  },
  {
    "key": "i_client_complain_power",
    "tr": "Kullanıcı Şikayet Gücü",
    "desc_tr": "Kullanıcı Şikayet Gücü",
    "desc_en": "Complain power"
  },
  {
    "key": "i_client_needed_complain_power",
    "tr": "Gereken Kullanıcı Şikayet Gücü",
    "desc_tr": "Gereken Kullanıcı Şikayet Gücü",
    "desc_en": "Needed complain power"
  },
  {
    "key": "b_client_complain_list",
    "tr": "Şikayet Listesini Görüntüle",
    "desc_tr": "Şikayet Listesini Görüntüler",
    "desc_en": "Show complain list"
  },
  {
    "key": "b_client_complain_delete_own",
    "tr": "Kendi Şikayetlerini Sil",
    "desc_tr": "Kendi Şikayetlerini Siler",
    "desc_en": "Delete own complains"
  },
  {
    "key": "b_client_complain_delete",
    "tr": "Tüm Şikayetleri Sil",
    "desc_tr": "Tüm Şikayetleri Siler",
    "desc_en": "Delete complains"
  },
  {
    "key": "b_client_ban_list",
    "tr": "Ban Listesini Görüntüle",
    "desc_tr": "Ban Listesini Görüntüler",
    "desc_en": "Show banlist"
  },
  {
    "key": "b_client_ban_create",
    "tr": "Ban Oluştur",
    "desc_tr": "Ban Oluşturur",
    "desc_en": "Add a ban"
  },
  {
    "key": "b_client_ban_delete_own",
    "tr": "Kendi Banlarını Sil",
    "desc_tr": "Kendi Banlarını Siler",
    "desc_en": "Delete own bans"
  },
  {
    "key": "b_client_ban_delete",
    "tr": "Kullanıcı Banları Sil",
    "desc_tr": "Kullanıcı Banlarını Siler",
    "desc_en": "Delete bans"
  },
  {
    "key": "i_client_ban_max_bantime",
    "tr": "Maks.Kullanıcı Banlama Süresi (saniye)",
    "desc_tr": "Maks.Kullanıcı Banlama Süresi (saniye)",
    "desc_en": "Max bantime"
  },
  {
    "key": "i_client_private_textmessage_power",
    "tr": "Özel Mesaj Gönderme Gücü",
    "desc_tr": "Özel mesaj gönderme gücünü alır",
    "desc_en": "Client private message power"
  },
  {
    "key": "i_client_needed_private_textmessage_power",
    "tr": "Gereken Özel Mesaj Gönderme Gücü",
    "desc_tr": "Özel mesaj göndermek için gerekli gücü alır",
    "desc_en": "Needed client private message power"
  },
  {
    "key": "b_client_server_textmessage_send",
    "tr": "Sunucuya Mesaj Gönder",
    "desc_tr": "Sunucuya Mesaj Gönderir",
    "desc_en": "Send text messages to virtual server"
  },
  {
    "key": "b_client_channel_textmessage_send",
    "tr": "Kanala Mesaj Gönder",
    "desc_tr": "Kanala Mesaj Gönderir",
    "desc_en": "Send text messages to channel"
  },
  {
    "key": "b_client_offline_textmessage_send",
    "tr": "Çevrimdışı Kullanıcılara Mesaj Gönder",
    "desc_tr": "Çevrimdışı Kullanıcılara Mesaj Gönderir",
    "desc_en": "Send offline messages to clients"
  },
  {
    "key": "i_client_talk_power",
    "tr": "Kullanıcı Konuşma gücü",
    "desc_tr": "Kullanıcı Konuşma gücü",
    "desc_en": "Client talk power"
  },
  {
    "key": "i_client_needed_talk_power",
    "tr": "Gereken Kullanıcı Konuşma Gücü",
    "desc_tr": "Konuşmak için gerekli gücü alır",
    "desc_en": "Needed client talk power"
  },
  {
    "key": "i_client_poke_power",
    "tr": "Kullanıcı Dürtme Gücü",
    "desc_tr": "Kullanıcı Dürtme Gücü",
    "desc_en": "Client poke power"
  },
  {
    "key": "i_client_needed_poke_power",
    "tr": "Gereken Kullanıcıyı Dürtme Gücü",
    "desc_tr": "Gereken Kullanıcıyı Dürtme Gücü",
    "desc_en": "Needed client poke power"
  },
  {
    "key": "b_client_set_flag_talker",
    "tr": "Diğer Kullanıcılara Konuşma Gücü Ver",
    "desc_tr": "Kullanıcılar için konuşmacıyı ayarlar ve konuşmalarına izin verir",
    "desc_en": "Set the talker flag for clients and allow them to speak"
  },
  {
    "key": "i_client_whisper_power",
    "tr": "Kullanıcı Fısıltı Gücü",
    "desc_tr": "Kullanıcı Fısıltı Gücü",
    "desc_en": "Client whisper power"
  },
  {
    "key": "i_client_needed_whisper_power",
    "tr": "Gereken Kullanıcı Fısıltı Gücü",
    "desc_tr": "Gereken Kullanıcı Fısıltı Gücü",
    "desc_en": "Client needed whisper power"
  },
  {
    "key": "b_client_modify_description",
    "tr": "Tüm Kullanıcı Açıklamalarını Düzenle",
    "desc_tr": "Kullanıcının açıklamasını düzenler",
    "desc_en": "Edit a clients description"
  },
  {
    "key": "b_client_modify_own_description",
    "tr": "Kendi Açıklamasını Düzenle",
    "desc_tr": "Kullanıcının kendi açıklamasını düzenlemesine izin verir",
    "desc_en": "Allow client to edit own description"
  },
  {
    "key": "b_client_modify_dbproperties",
    "tr": "ServerQuery: Kullanıcı Ayarlarını Düzenle",
    "desc_tr": "Veritabanında kullanıcının özelliklerini düzenler",
    "desc_en": "Edit a clients properties in the database"
  },
  {
    "key": "b_client_delete_dbproperties",
    "tr": "Kullanıcı Veritabanı Özelliklerini Sil",
    "desc_tr": "Veritabanında kullanıcının özelliklerini siler",
    "desc_en": "Delete a clients properties in the database"
  },
  {
    "key": "b_client_create_modify_serverquery_login",
    "tr": "ServerQuery hesabı oluştur ve düzenle",
    "desc_tr": "Kendi ServerQuery hesabını oluşturur veya düzenler",
    "desc_en": "Create or modify own ServerQuery account"
  },
  {
    "key": "b_ft_ignore_password",
    "tr": "Dosya İndirirken Kanal Parolasını Yoksay",
    "desc_tr": "Kanal şifresi olmadan dosyalara göz atar",
    "desc_en": "Browse files without channel password"
  },
  {
    "key": "b_ft_transfer_list",
    "tr": "ServerQuery: Aktif Dosya Aktarım Listesini Görüntüle",
    "desc_tr": "Devam eden dosya aktarımlarının listesini alır",
    "desc_en": "Retrieve list of running filetransfers"
  },
  {
    "key": "i_ft_file_upload_power",
    "tr": "Dosya Yükleme Gücü",
    "desc_tr": "Dosya Yükleme Gücü",
    "desc_en": "File upload power"
  },
  {
    "key": "i_ft_needed_file_upload_power",
    "tr": "Gereken Dosya Yükleme Gücü",
    "desc_tr": "Dosya yüklemek için gerekli gücü alır",
    "desc_en": "Needed file upload power"
  },
  {
    "key": "i_ft_file_download_power",
    "tr": "Dosya İndirme Gücü",
    "desc_tr": "Dosya indirme gücünü alır",
    "desc_en": "File download power"
  },
  {
    "key": "i_ft_needed_file_download_power",
    "tr": "Gereken Dosya İndirme Gücü",
    "desc_tr": "Dosya indirmek için gerekli gücü alır",
    "desc_en": "Needed file download power"
  },
  {
    "key": "i_ft_file_delete_power",
    "tr": "Dosya Silme Gücü",
    "desc_tr": "Dosya silme gücünü alır",
    "desc_en": "File delete power"
  },
  {
    "key": "i_ft_needed_file_delete_power",
    "tr": "Gereken Dosya Silme Gücü",
    "desc_tr": "Dosya silmek için gerekli gücü alır",
    "desc_en": "Needed file delete power"
  },
  {
    "key": "i_ft_file_rename_power",
    "tr": "Dosya Adını Değiştirme Gücü",
    "desc_tr": "Dosya yeniden adlandırma gücünü alır",
    "desc_en": "File rename power"
  },
  {
    "key": "i_ft_needed_file_rename_power",
    "tr": "Gereken Dosya Adını Değiştirme Gücü",
    "desc_tr": "Dosya yeniden adlandırmak için gerekli gücü alır",
    "desc_en": "Needed file rename power"
  },
  {
    "key": "i_ft_file_browse_power",
    "tr": "Dosya Listesini Görüntüleme Gücü",
    "desc_tr": "Dosyalara göz atma gücünü alır",
    "desc_en": "File browse power"
  },
  {
    "key": "i_ft_needed_file_browse_power",
    "tr": "Gereken Dosya Listesini Görüntüleme Gücü",
    "desc_tr": "Dosyalara göz atmak için gerekli gücü alır",
    "desc_en": "Needed file browse power"
  },
  {
    "key": "i_ft_directory_create_power",
    "tr": "Dosya Arşivi Oluşturma Gücü",
    "desc_tr": "Dizin oluşturma gücünü alır",
    "desc_en": "Create directory power"
  },
  {
    "key": "i_ft_needed_directory_create_power",
    "tr": "Gereken Dosya Arşivi Oluşturma Gücü",
    "desc_tr": "Dizin oluşturmak için gerekli gücü alır",
    "desc_en": "Needed create directory power"
  },
  {
    "key": "i_ft_quota_mb_download_per_client",
    "tr": "Kullanıcı Dosya İndirme Sınırı(MByte)",
    "desc_tr": "Kullanıcı başına indirme kotası (MB)",
    "desc_en": "Download quota per client in MByte"
  },
  {
    "key": "i_ft_quota_mb_upload_per_client",
    "tr": "Kullanıcı Dosya Yükleme Sınırı(MByte)",
    "desc_tr": "Kullanıcı başına yükleme kotası (MB)",
    "desc_en": "Upload quota per client in MByte"
  },
  {
    "key": "i_needed_modify_power_serverinstance_help_view",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_serverinstance_info_view",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_serverinstance_virtualserver_list",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_serverinstance_binding_list",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_serverinstance_permission_list",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_serverinstance_permission_find",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_create",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_delete",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_start_any",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_stop_any",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_change_machine_id",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_change_template",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_serverquery_login",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_serverquery_login_create",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_serverquery_login_delete",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_serverquery_login_list",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_serverinstance_textmessage_send",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_serverinstance_log_view",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_serverinstance_log_add",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_serverinstance_stop",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_serverinstance_modify_settings",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_serverinstance_modify_querygroup",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_serverinstance_modify_templates",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_select",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_info_view",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_connectioninfo_view",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_channel_list",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_channel_search",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_client_list",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_client_search",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_client_dblist",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_client_dbsearch",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_client_dbinfo",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_permission_find",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_custom_search",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_start",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_stop",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_token_list",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_token_add",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_token_use",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_token_delete",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_apikey_add",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_apikey_manage",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_log_view",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_log_add",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_join_ignore_password",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_notify_register",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_notify_unregister",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_snapshot_create",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_snapshot_deploy",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_permission_reset",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_modify_name",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_modify_welcomemessage",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_modify_maxclients",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_modify_reserved_slots",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_modify_password",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_modify_default_servergroup",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_modify_default_channelgroup",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_modify_default_channeladmingroup",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_modify_channel_forced_silence",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_modify_complain",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_modify_antiflood",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_modify_ft_settings",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_modify_ft_quotas",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_modify_hostmessage",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_modify_hostbanner",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_modify_hostbutton",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_modify_port",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_modify_autostart",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_modify_needed_identity_security_level",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_modify_priority_speaker_dimm_modificator",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_modify_log_settings",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_modify_min_client_version",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_modify_icon_id",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_modify_weblist",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_modify_codec_encryption_mode",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_modify_temporary_passwords",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_modify_temporary_passwords_own",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_modify_channel_temp_delete_delay_default",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_modify_nickname",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_modify_integrations",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_min_depth",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_max_depth",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_group_inheritance_end",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_permission_modify_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_needed_permission_modify_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_info_view",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_create_child",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_create_permanent",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_create_semi_permanent",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_create_temporary",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_create_with_topic",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_create_with_description",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_create_with_password",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_create_with_banner",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_create_modify_with_codec_opusvoice",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_create_modify_with_codec_opusmusic",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_create_modify_with_codec_maxquality",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_create_modify_with_codec_latency_factor_min",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_create_with_maxclients",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_create_with_maxfamilyclients",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_create_with_sortorder",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_create_with_default",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_create_with_needed_talk_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_create_modify_with_force_password",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_create_modify_with_temp_delete_delay",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_modify_parent",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_modify_make_default",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_modify_make_permanent",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_modify_make_semi_permanent",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_modify_make_temporary",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_modify_name",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_modify_topic",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_modify_description",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_modify_password",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_modify_banner",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_modify_codec",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_modify_codec_quality",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_modify_codec_latency_factor",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_modify_maxclients",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_modify_maxfamilyclients",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_modify_sortorder",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_modify_needed_talk_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_modify_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_needed_modify_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_modify_make_codec_encrypted",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_modify_temp_delete_delay",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_delete_permanent",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_delete_semi_permanent",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_delete_temporary",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_delete_flag_force",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_delete_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_needed_delete_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_join_permanent",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_join_semi_permanent",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_join_temporary",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_join_ignore_password",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_join_ignore_maxclients",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_join_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_needed_join_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_subscribe_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_needed_subscribe_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_description_view_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_channel_needed_description_view_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_icon_id",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_max_icon_filesize",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_icon_manage",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_group_is_permanent",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_group_auto_update_type",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_group_auto_update_max_value",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_group_sort_id",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_group_show_name_in_tree",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_servergroup_list",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_servergroup_permission_list",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_servergroup_client_list",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_channelgroup_list",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_channelgroup_permission_list",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_channelgroup_client_list",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_client_permission_list",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_channel_permission_list",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_channelclient_permission_list",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_servergroup_create",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_channelgroup_create",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_group_modify_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_group_needed_modify_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_group_member_add_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_group_needed_member_add_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_group_member_remove_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_group_needed_member_remove_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_permission_modify_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_permission_modify_power_ignore",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_servergroup_delete",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_virtualserver_channelgroup_delete",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_permission_modify_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_needed_permission_modify_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_max_clones_uid",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_max_idletime",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_max_avatar_filesize",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_max_channel_subscriptions",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_is_priority_speaker",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_skip_channelgroup_permissions",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_force_push_to_talk",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_ignore_bans",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_ignore_antiflood",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_use_reserved_slot",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_use_channel_commander",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_request_talker",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_avatar_delete_other",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_is_sticky",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_ignore_sticky",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_info_view",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_permissionoverview_view",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_permissionoverview_own",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_remoteaddress_view",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_serverquery_view_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_needed_serverquery_view_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_custom_info_view",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_kick_from_server_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_needed_kick_from_server_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_kick_from_channel_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_needed_kick_from_channel_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_ban_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_needed_ban_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_move_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_needed_move_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_complain_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_needed_complain_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_complain_list",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_complain_delete_own",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_complain_delete",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_ban_list",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_ban_create",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_ban_delete_own",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_ban_delete",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_ban_max_bantime",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_private_textmessage_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_needed_private_textmessage_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_server_textmessage_send",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_channel_textmessage_send",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_offline_textmessage_send",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_talk_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_needed_talk_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_poke_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_needed_poke_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_set_flag_talker",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_whisper_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_needed_whisper_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_modify_description",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_modify_own_description",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_modify_dbproperties",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_delete_dbproperties",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_client_create_modify_serverquery_login",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_ft_ignore_password",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_ft_transfer_list",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_ft_file_upload_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_ft_needed_file_upload_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_ft_file_download_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_ft_needed_file_download_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_ft_file_delete_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_ft_needed_file_delete_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_ft_file_rename_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_ft_needed_file_rename_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_ft_file_browse_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_ft_needed_file_browse_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_ft_directory_create_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_ft_needed_directory_create_power",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_ft_quota_mb_download_per_client",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  },
  {
    "key": "i_needed_modify_power_ft_quota_mb_upload_per_client",
    "tr": "",
    "desc_tr": "",
    "desc_en": ""
  }
];

export const PERM_TR = PERM_TR_LIST.reduce((acc, x) => {
  acc[x.key] = x;
  return acc;
}, {});
